import { Module, VuexModule, Mutation } from 'vuex-module-decorators'

@Module({ namespaced: true, name: 'UiModule' })
export default class UiModule extends VuexModule {
  public globalLoading = false

  @Mutation
  setGlobalLoading(val: boolean) {
    this.globalLoading = val
  }
}